import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Collapse from "react-bootstrap/Collapse";
import PageTitle from "../../layouts/PageTitle";

const options = [
  //{ value: '1', label: 'Select Status' },
  { value: "2", label: "Published" },
  { value: "3", label: "Draft" },
  { value: "4", label: "Trash" },
  { value: "5", label: "Private" },
  { value: "6", label: "Pending" },
];

const tableData = [
  { number: "1", title: "Title of first blog post entry" },
  { number: "2", title: "Why Go For A VFX Course?" },
  { number: "3", title: "Reasons To Choose Animation Courses" },
  { number: "4", title: "Blue Screen Vs. Green Screen For VFX" },
  { number: "5", title: "All About Animation" },
];

const Settings = () => {
  const [open, setOpen] = useState(true);

  const pages = [
    { name: "Degree", icon: "fas fa-graduation-cap", link: "/degree" },
    { name: "Course Type", icon: "fas fa-graduation-cap", link: "/course-type" },
    { name: "Intake", icon: "fas fa-user-graduate", link: "/intake" },
    { name: "Field", icon: "fas fa-file-alt", link: "/field" },
    { name: "Application", icon: "fa-solid fa-file-pen", link: "/application" },
    { name: "University", icon: "fas fa-university", link: "/university" },
    { name: "Subject", icon: "fas fa-book", link: "/subject" },
    { name: "Language", icon: "fas fa-globe", link: "/language" },
    { name: "Duration", icon: "fas fa-hourglass-half", link: "/duration" },
    // {
    //   name: "Currency",
    //   icon: "fa-solid fa-circle-dollar-to-slot",
    //   link: "/currency",
    // },
    // {
    //   name: "Visa Category",
    //   icon: "fas fa-file-text",
    //   link: "/visa-category",
    // },
    {
      name: "Accommodation Type",
      icon: "fas fa-home",
      link: "/accommodation-type",
    },
    {
      name: "Accommodation Bed",
      icon: "fas fa-bed",
      link: "/accommodation-bed",
    },
    {
      name: "Forex Service",
      icon: "fas fa-money-bill-wave",
      link: "/forex-service",
    },
    { name: "Bank", icon: "fas fa-money-bill-wave", link: "/bank" },
    { name: "Subscribe User Emails", icon: "fas fa-solid fa-envelope-open-text", link: "/subscribe-user" },
    { name: "Subscribe User Logs", icon: "fas fa-solid fa-envelope-circle-check", link: "/subscribe-user-log" },
  ];

  const [data, setData] = useState(
    document.querySelectorAll("#blog_wrapper tbody tr")
  );
  const sort = 8;
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  useEffect(() => {
    setData(document.querySelectorAll("#blog_wrapper tbody tr"));
  }, [test]);

  activePag.current === 0 && chageData(0, sort);
  return (
    <>
      <PageTitle
        activeMenu="Settings"
        motherMenu="Settings"
        activeMenuLink={"settings"}
        motherMenuLink={"settings"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`} onClick={() => setOpen(!open)}>
              <div className="cpa">
                <i className="fas fa-cog me-2"></i>Go to
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    {pages.map((page, index) => (
                      <div
                        className="col-xl-3 col-md-4 col-sm-6 col-12 mb-4"
                        key={index}
                      >
                        <Link to={page.link} className="text-decoration-none">
                          <div className="card dashboard-card h-100 text-center">
                            <div className="card-body d-flex flex-column justify-content-center align-items-center">
                              <i
                                className={`${page.icon} fa-2x mb-3 text-primary`}
                              ></i>
                              <h6 className="mb-0">{page.name}</h6>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};
export default Settings;
